import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import '../styles/Landing.css';
import Back1 from '../images/back3.webp';
import Logo from '../images/school_logo.png';
import Loader from "./Loader";
import {SCHOOL_ADDRESS, SCHOOL_PHONE } from '../Variables.js';

const Landing = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadImage = (src) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = src;
        img.onload = resolve;
      });
    };

    loadImage(Back1).then(() => setLoading(false));
  }, []);

  if (loading) {
    return <Loader text={"STARTING"}/>;
  }

  return (
    <>
      <div className="landing-page-div visible" style={{ backgroundImage: `url(${Back1})` }}>
        <div className="landing-page-top">
          <div className="column align-center justify-center">
            <img src={Logo} className="landing-logo" alt="logo" />
            <p className="text-center"><span className="title size2">AKADEMIA</span><br/><span className="bold size3">Schools</span><br/><span className="size5 italics">{SCHOOL_ADDRESS}</span><br/><span className="size5 italics">{SCHOOL_PHONE}</span></p>            
          </div>
        </div>
        <div className="landing-page-bottom">
          <div>
            <Link className="landing-button login row align-center justify-center size5 bold" to="/login">GET STARTED</Link>            
            <p className="paystack align-center justify-center">Produced by &nbsp;<a href="https://deroyale.com.ng" target="blank" className="logo size4 bold">DeRoy<span className="font-gold deroyale-at" style={{fontFamily: "'Cabin', Helvetica, Arial, sans-serif'"}}>@</span>l&#233;</a></p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Landing;